module.exports = __webpack_public_path__ + "static/assets/d2a93b52c5d7437c11a924c7541f526c.png";